import { setCookie, getCookie } from './cookies';

const $promoBanner = $( '.c-promo-banner' );
const promoBannerID = $promoBanner.attr( 'data-promo-id' );
const cookieName = 'rootworks_promo';
const cookie = getCookie( cookieName );

if ( $promoBanner.length && cookie && cookie === promoBannerID ) {
	$promoBanner.hide(); // Hide alert if its ID exists in cookie.
}

$( document ).on( 'click', '.js-banner-close', function( e ) {
	e.preventDefault();
	$promoBanner.hide();

	setCookie( cookieName, promoBannerID );
} );
